import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeRadius } from "styles/appThemeTokens";

const uiFont = appThemeFonts.family.ui;

export const OptionGroupLabel = styled(Typography)({
  display: "block",
  fontSize: appThemeFonts.size.md,
  fontWeight: 600,
  color: appThemeColors.text.primary,
  marginBottom: 8,
});

export const OptionGroupRequiredMark = styled("span")({
  color: appThemeColors.semantic.danger,
});

export const OptionGroupList = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 2,
  border: `1px solid ${appThemeColors.border.default}`,
  borderRadius: 10,
  padding: 6,
  backgroundColor: appThemeColors.background.paper2,
});

export const OptionGroupButton = styled("button")({
  display: "flex",
  alignItems: "center",
  gap: 11,
  width: "100%",
  textAlign: "left",
  padding: "8px 9px",
  border: 0,
  background: "none",
  borderRadius: appThemeRadius.md,
  cursor: "pointer",
  fontFamily: uiFont,
  "&:hover": {
    backgroundColor: appThemeColors.background.kbd,
  },
  "&:focus-visible": {
    outline: "2px solid #0B5FA5",
    outlineOffset: "2px",
  },
  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.55,
  },
});

export const OptionGroupCheckbox = styled("span", {
  shouldForwardProp: (prop) => prop !== "$checked",
})(({ $checked }) => ({
  width: 18,
  height: 18,
  flex: "0 0 auto",
  borderRadius: 5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: $checked ? 0 : `1px solid ${appThemeColors.border.strong}`,
  background: $checked
    ? appThemeColors.text.lightBlue
    : appThemeColors.background.paper,
}));

export const OptionGroupRadio = styled("span", {
  shouldForwardProp: (prop) => prop !== "$checked",
})(({ $checked }) => ({
  width: 18,
  height: 18,
  flex: "0 0 auto",
  boxSizing: "border-box",
  borderRadius: "9999px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: $checked
    ? `5px solid ${appThemeColors.text.lightBlue}`
    : `1px solid ${appThemeColors.border.strong}`,
  background: appThemeColors.background.paper,
}));

export const OptionGroupCheckIcon = styled(CheckIcon)({
  fontSize: appThemeFonts.size.base,
  color: appThemeColors.neutral.white,
});

export const OptionGroupText = styled(Box)({
  minWidth: 0,
});

export const OptionGroupItemLabel = styled(Typography)({
  display: "block",
  fontSize: appThemeFonts.size.basePlus,
  fontWeight: 400,
  color: appThemeColors.text.primary,
  lineHeight: 1.3,
});

export const OptionGroupItemHint = styled(Typography)({
  display: "block",
  fontSize: appThemeFonts.size.smPlus,
  fontWeight: 400,
  color: appThemeColors.text.faint,
  marginTop: 1,
  lineHeight: 1.35,
});

export const OptionGroupHint = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$error",
})(({ $error }) => ({
  fontSize: $error ? appThemeFonts.size.md : appThemeFonts.size.smPlus,
  color: $error ? appThemeColors.semantic.danger : appThemeColors.text.faint,
  marginTop: 6,
  lineHeight: 1.4,
}));
